import React from 'react';
import { Avatar, Box, Modal, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { IUserState } from '../../Core/State/IUserState';

interface ProfileModalProps {
    open: boolean;
    handleClose: () => void;
    userState: IUserState;
}

class ProfileModal extends React.Component<ProfileModalProps> {
    render() {
        const { open, handleClose, userState } = this.props;
        const avatarUrl = userState.avatarUrl;

        return (
            <>
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="user-profile-modal-title"
                    aria-describedby="user-profile-modal-description"
                >
                    <Box sx={{
                        position: 'absolute',
                        top: '10%',
                        left: '50%',
                        color: 'white',
                        transform: 'translate(-50%, -10%)',
                        width: 400,
                        bgcolor: 'background.paper',
                        border: '2px solid #000',
                        boxShadow: 24,
                        p: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}>
                        <IconButton
                            aria-label="close"
                            onClick={handleClose}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography id="user-profile-modal-title" variant="h6" component="h2" sx={{ alignSelf: 'center', fontWeight: 'bold' }}>
                            User Profile
                        </Typography>
                        <Box sx={{ mt: 2, alignSelf: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Avatar src={avatarUrl || undefined} alt="Avatar" sx={{ width: 104, height: 104 }} />
                        </Box>
                        <Typography id="user-profile-modal-description" sx={{ mt: 2, textAlign: 'center' }}>
                            <strong>Username:</strong> {userState.username}
                        </Typography>
                        <Typography sx={{ mt: 2, textAlign: 'center' }}>
                            <strong>First Name:</strong> {userState.firstname}
                        </Typography>
                        <Typography sx={{ mt: 2, textAlign: 'center' }}>
                            <strong>Last Name:</strong> {userState.lastname}
                        </Typography>
                        <Typography sx={{ mt: 2, textAlign: 'center' }}>
                            <strong>Balance:</strong> ${Number(userState.balance).toFixed(2)} 
                        </Typography>
                    </Box>
                </Modal>
            </>
        );
    }
}

export default ProfileModal;
